import React, { useEffect, useState } from 'react'
import { EventsDetailMain, EventsDetailSidebar } from './subcomponents'
import { Container } from '@components/Globals'
import { Column, Row } from '@components/Common'
import Banner from '@components/Banner'
import { createEvent, timezone2tzid } from '@utils'
import moment from 'moment-timezone'

const EventsDetailContent = ({ parentPage, event }) => {
  const [url, setUrl] = useState(null)
  const [isPastEvent, setIsPastEvent] = useState(false)
  const title = event?.title || 'Paul Hastings Event'
  const file = `${title}.ics`

  const eventDetail = createEvent({ ...event, title })

  const saveFile = (dat, filename) => {
    const blob = new Blob([`${dat}`], { type: 'text/calendar' })
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename)
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && eventDetail) {
      if (!window.navigator.msSaveOrOpenBlob) {
        setUrl(
          window.URL.createObjectURL(
            new Blob([`${eventDetail}`], { type: 'text/calendar' })
          )
        )
      }
    }
  }, [eventDetail])

  useEffect(() => {
    if (event?.eventTimes?.length || event?.eventEnd) {
      const eventTimes = event?.eventTimes || [
        {
          eventEnd: event?.eventEnd,
          timeZone: event?.timeZone,
          eventStart: event?.eventStart,
        },
      ]

      const hasNotEnded = eventTimes.some(({ eventEnd, timeZone }) => {
        const tzid = timezone2tzid[timeZone]
        const eventEndMoment = moment.tz(eventEnd, tzid)
        const now = moment()
        return eventEndMoment.isAfter(now)
      })

      setIsPastEvent(!hasNotEnded)
    }
  }, [event])

  return (
    <Container fluid>
      <Row>
        <Column className="mb-10">
          <Banner
            stacked
            breadcrumbs
            height="22"
            to={parentPage?.slug}
            crumbLabel={'Events'}
            gradient="blue-gold"
          >
            <EventsDetailMain
              {...event}
              event={event}
              parentPath={parentPage?.slug}
              url={url}
              file={file}
              eventDetail={eventDetail}
              saveFile={saveFile}
              isPastEvent={isPastEvent}
            />
            <br />
            <Column className="max-w-135 w-full my-5 mx-auto md:w-[26%] md:mt-[55px] md:ml-10 xl:ml-[8.3%]">
              <EventsDetailSidebar
                {...event}
                event={event}
                eventDetail={eventDetail}
                saveFile={saveFile}
                file={file}
                isPastEvent={isPastEvent}
                url={url}
                parentPath={parentPage?.slug}
              />
            </Column>
          </Banner>
        </Column>
      </Row>
    </Container>
  )
}

export default EventsDetailContent
